import { render } from "./EditSalesmanShopsModal.vue?vue&type=template&id=0787a248"
import script from "./EditSalesmanShopsModal.vue?vue&type=script&lang=js"
export * from "./EditSalesmanShopsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__